module.exports = __webpack_public_path__ + "static/media/logo_SSC_F.f00f18fb.png";